import { Chatbox } from "@talkjs/react";
import { User } from "@core/features/auth";
import { Loader } from "@themes/pollinator/ui/Loader";
import { Sheet } from "@themes/pollinator/ui/Sheet";
import { AppPageHeader } from "@themes/pollinator/ui/AppPageHeader";
import { TalkJSData } from "@core/features/chat";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  talkjsData: TalkJSData | null | undefined;
  user: User | null | undefined;
};

export function ChatSheet({
  isLoading = false,
  isOpen,
  onClose,
  talkjsData,
  user,
}: Props) {
  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      className="max-w-lg overflow-auto"
      innerClassName="justify-start"
    >
      <div className="flex-1 flex flex-col p-0">
        <AppPageHeader title="Circle Chat" className="px-4 py-8 border-b" />
        {isLoading || !talkjsData || !user ? (
          <Loader isFullPage />
        ) : (
          <div className="flex flex-1 flex-col gap-4">
            {talkjsData.app_id && talkjsData.user_id && talkjsData.token ? (
              <>
                {talkjsData.conversations.map((conversationId) => (
                  <Chatbox
                    key={conversationId}
                    conversationId={conversationId}
                    loadingComponent={<Loader />}
                    style={{ width: "100%", height: "100%" }}
                  />
                ))}
              </>
            ) : (
              <div className="flex flex-col h-full gap-4 items-center justify-center">
                <Type variant="body2">No conversations found.</Type>
              </div>
            )}
          </div>
        )}
      </div>
    </Sheet>
  );
}

export default ChatSheet;


